module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Localization</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"rtl\" ")
    ; __append(escapeFn( u.isTrue(rtl) ? "checked" : "" ))
    ; __append(" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Right to Left (RTL)</label></div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}